import styled from 'styled-components';

export const ReportWrapper = styled.div`
  min-height: 800px;
  margin: -2rem 1rem 1rem;
  iframe {
    min-height: 800px;
    border: 0;
  }
`;
